module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-how-does-it-work-box.html
// module id = 548
// module chunks = 0